import React, { createRef, useState } from "react";
import PropTypes from "prop-types";
import Modal from "./Modal";
import Button from "./Button";
// import { isValid } from "ipaddr.js";

const ModalPassword = ({
  title,
  invalidText,
  loginButton,
  password,
  onLogin,
  isOpen,
  isValid
}) => {
  const passwordRef = createRef();
  const [isInvalid, setIsInvalid] = useState(false);

  const handleSubmit = e => {
    const passwordVal = passwordRef.current.value;

    if (password === passwordVal) {
      passwordRef.current.blur();
      setIsInvalid(false);
      isValid();
      onLogin();
    } else {
      setIsInvalid(true);
    }
    e.preventDefault();
  };

  const showPassword = () => {
    const input = document.getElementById("password-input");

    if (input.getAttribute("type") === "password") {
      input.setAttribute("type", "text");
    } else {
      input.setAttribute("type", "password");
    }
  };

  const passwordClass = isInvalid ? "is-error" : "";
  const feedbackClass = `invalid-feedback ${isInvalid ? "" : "is-hidden"}`;

  return (
    <Modal isOpen={isOpen} isWithCloseButton={false} className="modal-password">
      <div className="modal-password-title">
        <h3>{title}</h3>
      </div>
      <div className="modal-hanger">
        <img src="/wp-content/themes/teamconnector2/assets/images/hanger.png" />
        <img src="/wp-content/themes/teamconnector2/assets/images/hanger.png" />
      </div>
      <div className="modal-input-password">
        <form onSubmit={handleSubmit}>
          <div className="modal-input-password--input">
            <input
              type="password"
              ref={passwordRef}
              id="password-input"
              className={passwordClass}
            />
            <button
              type="button"
              onClick={showPassword}
              className="show-password"
            >
              <img src="/wp-content/themes/teamconnector2/assets/images/eye-slash.png" />
            </button>
          </div>
          <div className={feedbackClass}>{invalidText}</div>
        </form>
        <Button
          type="submit"
          {...loginButton}
          className="modal-password-login"
          onClick={handleSubmit}
        />
        <button type="button" className="cancel-submit-password">
          <span>Cancel</span>
        </button>
      </div>
    </Modal>
  );
};

ModalPassword.propTypes = {
  title: PropTypes.string,
  invalidText: PropTypes.string,
  loginButton: PropTypes.shape(Button.propTypes),
  onLogin: PropTypes.func,
  isOpen: PropTypes.bool
};

ModalPassword.defaultProps = {
  onSubmit: () => {},
  isOpen: false
};

export default ModalPassword;
